import React from 'react';
import { Chip, Typography } from '@mui/material';
import { ReactComponent as FolderIcon } from 'new/components/icons/folder.svg';
import { Link } from 'react-router-dom';

import styles from './ProjectPipelineChip.module.scss';

interface ProjectPipelineChipProps {
  id: string;
  name: string;
  disabled?: boolean;
}

const handleClick = (e: React.MouseEvent) => e?.stopPropagation();

const ProjectPipelineChip: React.FC<ProjectPipelineChipProps> = ({ id, name, disabled }) => {
  if (!id || !name) return null;

  const to = `/integrate/projects/${id}`;

  const label = disabled ? (
    <span className={styles.link}>
      <FolderIcon width="12px" height="11px" />
      <Typography variant="body3" className={styles.projectName} title={name}>
        {name}
      </Typography>
    </span>
  ) : (
    <Link to={to} className={styles.link}>
      <FolderIcon width="12px" height="11px" />
      <Typography variant="body3" className={styles.projectName} title={name}>
        {name}
      </Typography>
    </Link>
  );

  return (
    <Chip
      size="small"
      color="warning"
      data-not-expanding="true"
      onClickCapture={handleClick}
      classes={{
        label: styles.chipLabel,
        root: styles.chipRootProject,
      }}
      label={label}
    />
  );
};

ProjectPipelineChip.displayName = 'ProjectPipelineChip';

export default ProjectPipelineChip;
